exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-info-modal{-webkit-box-align:end!important;-ms-flex-align:end!important;align-items:flex-end!important}.order-info-modal .modal-body{width:100%!important;border-radius:20px 20px 0 0!important}.order-info-modal .modal-body .modal-scroll{height:75vh;background:#fff}.order-info-modal .modal-content .modal-split{width:100vw;max-width:979px;padding-bottom:20px}.order-info-modal .modal-content .modal-split .modal-right{width:100%;padding:0!important}", ""]);

// exports
